import React, { Component } from 'react';
import * as Styles from './Styles';

type Props = {
	title: string;
	value: string;
	price: number;
};

type State = {};

class Item extends Component<Props, State> {
	state = {};

	render() {
		return (
			<Styles.ItemContainer>
				<Styles.ItemTitleFont>{this.props.title}</Styles.ItemTitleFont>
				<Styles.ItemDetailsContainer>
					<p>{this.props.value.split(',').join(' ')}</p>
					<p>{this.props.price} zł</p>
				</Styles.ItemDetailsContainer>
			</Styles.ItemContainer>
		);
	}
}

export default Item;
